import {isServer} from "./index";

export default (ref) => {
  if (!ref || isServer()) {
    return false;
  }

  const bounding = ref.getBoundingClientRect();

  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};



// WEBPACK FOOTER //
// ./utils/isInViewport.js